import { httpsCallable } from "firebase/functions";
import { cloudFunctions } from "./getFunctions";
import {
  AsignarCustomClaim,
  CloudFunctionResponse,
  CallablesGeneral
} from "@fixeduy/restaurantestypes";

const asignarCustomClaim = async (
  data: AsignarCustomClaim
): Promise<CloudFunctionResponse> => {
  const run = httpsCallable<CallablesGeneral, CloudFunctionResponse>(
    cloudFunctions,
    "callablesGenerales"
  );
  const result = await run({
    func: "asignarCustomClaim",
    params: data
  });
  return result.data;
};

export { asignarCustomClaim };
